import gql from 'graphql-tag';

const VENDOR_LIST_ADD = gql`
  mutation Mutation($vendor: String!) {
    addMfgVendor(vendor: $vendor) {
      code
    }
  }
`;

export default VENDOR_LIST_ADD;
